import { render, staticRenderFns } from "./CampaignTable.vue?vue&type=template&id=5406a940&scoped=true"
import script from "./CampaignTable.vue?vue&type=script&lang=js"
export * from "./CampaignTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignTable.vue?vue&type=style&index=0&id=5406a940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406a940",
  null
  
)

export default component.exports